import { Card, Separator } from '@repo/shadcn';
import { FC } from 'react';

import { formatCurrencyInBDT } from '@/utils';

import { useSalesSummary } from './sales-summary.hook';

export const SalesSummary: FC = () => {
    const { data, isError, isFetching, isLoading, error } = useSalesSummary();

    if (isLoading || isFetching) {
        return <LoadingSkeleton />;
    }

    if (isError || !data || !data?.data) {
        return <ErrorComponent error={error} />;
    }

    return (
        <Card className="pt-3">
            <h2 className={'px-2 text-xl font-medium'}>Sales Summary</h2>

            <div className={'font-xl mt-3 grid grid-cols-1 font-medium'}>
                <div className={'grid grid-cols-2 bg-gray-50 p-2'}>
                    <span>Total Sale</span>
                    <span className={'block text-right'}>
                        {data?.data?.total_orders}
                    </span>
                </div>

                <Separator />

                <div className={'grid grid-cols-2 bg-white p-2'}>
                    <span>Total Sales Amount</span>
                    <span className={'block text-right'}>
                        {formatCurrencyInBDT(data?.data?.total_price || 0)}
                    </span>
                </div>

                <Separator />

                <div className={'grid grid-cols-2 bg-gray-50 p-2'}>
                    <span>Total Paid Amount</span>
                    <span className={'block text-right'}>
                        {formatCurrencyInBDT(
                            data?.data?.total_paid_amount || 0,
                        )}
                    </span>
                </div>

                <Separator />

                <div className={'grid grid-cols-2 bg-white p-2'}>
                    <span>Total Due Amount</span>
                    <span className={'block text-right'}>
                        {formatCurrencyInBDT(data?.data?.total_due_amount || 0)}
                    </span>
                </div>

                <Separator />

                <div className={'grid grid-cols-2 bg-gray-50 p-2'}>
                    <span>Estimated Profit</span>
                    <span className={'block text-right'}>
                        {formatCurrencyInBDT(
                            data?.data?.total_estimated_profit_margin || 0,
                        )}
                    </span>
                </div>
            </div>
        </Card>
    );
};

const LoadingSkeleton: FC = () => {
    return (
        <Card className="pt-2">
            <h2 className={'px-2 text-xl font-medium'}>Sales Summary</h2>

            <div className={'font-xl mt-4 grid grid-cols-1 font-medium'}>
                {Array.from({ length: 5 }).map((_, index) => (
                    <div
                        key={index}
                        className={
                            'grid animate-pulse grid-cols-2 bg-gray-50 p-2'
                        }
                    >
                        <span className="h-4 w-3/4 rounded bg-gray-300"></span>
                        <span className="h-4 w-1/2 self-end justify-self-end rounded bg-gray-300"></span>
                    </div>
                ))}
            </div>
        </Card>
    );
};

const ErrorComponent: FC<{ error: any }> = ({ error }) => {
    return (
        <Card className="pt-2">
            <h2 className={'px-2 text-xl font-medium'}>Sales Summary</h2>
            <div className={'font-xl mt-4 grid grid-cols-1 font-medium'}>
                <p className="text-red-500">Failed to load sales summary.</p>
                <p className="text-red-500">
                    {error?.message || 'Unknown error'}
                </p>
            </div>
        </Card>
    );
};
